import { WebAppIds } from "../../AppWrapper2/types.js";
import { RPCDocs } from "../../../services/rpc.js";
// src/modules/SystemInfo/shared/constants.ts
var Type = RPCDocs.System.GetSystemInfoForTarget.v1.Type;
var Target = RPCDocs.System.GetSystemInfoForTarget.v1.Target;
var TypeBackgroundColors = {
	[Type.Announcement]: "rgba(23,255,193,0.2)",
	[Type.Changelog]: "rgba(169,214,245,0.2)"
};
/**
* Every web-app that renders the app shell needs a Target - `target` is a
* required arg of system::get-system-info-for-target. Profile & Sentinel have no
* Target of their own, so they read the posts published to every app.
*/
var AppIdToTargetMap = {
	[WebAppIds.Admin]: Target.Admin,
	[WebAppIds.Dispatch]: Target.Dispatch,
	[WebAppIds.IntegrationSentinel]: Target.All,
	[WebAppIds.Ops]: Target.Ops,
	[WebAppIds.Portal]: Target.Portal,
	[WebAppIds.Profile]: Target.All,
	[WebAppIds.Scheduling]: Target.Scheduling
};
/**
* `currentAppId` is '' until AppShellBootstrap syncs it into AppShellViewModel
* (an effect, so one render after mount) and is typed loosely enough to be any
* string. Returns undefined for an id we can't map so callers hold the RPC call
* instead of sending `target: undefined`.
*/
function getSystemInfoTarget(appId) {
	return AppIdToTargetMap[appId];
}
var metadataLastSawDatePropName = "systemInfoLastSawDate";
export { AppIdToTargetMap, TypeBackgroundColors, getSystemInfoTarget, metadataLastSawDatePropName };

//# sourceMappingURL=constants.js.map